import client from '../client'
import imageUrlBuilder from '@sanity/image-url'

// Helper functions to display content from sanity

export default function urlFor(source) {
    return imageUrlBuilder(client).image(source)
}